// extracted by mini-css-extract-plugin
export var chevron = "_jd-2";
export var dropdownItems = "_jd-0";
export var item = "_jd-1";